import { withInstall } from '@xzx-design/utils'
import _Cascader from './src/cascader.tsx'

export const Cascader = withInstall(_Cascader)
export default Cascader

export * from './src/cascader'
export * from './src/types'
